<template>
  <div>
    <v-btn
      class="btn-kakao mb-3"
      x-large
      depressed
      block
      rounded
      @click="kakaoLogin()"
      >{{ btnLabel }}</v-btn
    >
  </div>
</template>
<script>
import { mapActions } from "vuex";

export default {
  props: {
    btnLabel: {
      type: String,
      default: "카카오 로그인",
    },
  },
  methods: {
    kakaoLogin() {
      const _self = this;
      window.Kakao.Auth.login({
        scope: "",
        success: function (response) {
          window.Kakao.Auth.setAccessToken(response.access_token);
          console.log(`is set?: ${window.Kakao.Auth.getAccessToken()}`);
          // _self.getKakaoAccount();
          _self.getKakaoAgree();
        },
      });
    },
    /** 문제해결 -> sdk버전문제 -> /v1/user/service/terms 사용해야 데이터가 넘어옴 */
    getKakaoAgree() {
      const _self = this;
      window.Kakao.API.request({
        // url: "/v2/user/service_terms",
        url: "/v1/user/service/terms",
        success: (response) => {
          // 동의항목중 tag에서 -> marketingSMSConsent_240510의 동의일자 확인
          console.log("Kakao scopes response", response);
          const obj = response.allowed_service_terms;
          const itemIdx = obj
            .map((x) => x.tag)
            .indexOf("marketingSMSConsent_240510");
          console.log("itemIdx", itemIdx);
          let smsMarketingAgree = false;
          if (itemIdx > -1) {
            console.log("sms마켓팅 동의 일자", obj[itemIdx].agreed_at);
            const agreeDate = obj[itemIdx].agreed_at;
            // 유효성검사
            if (this.$moment(agreeDate).isValid()) smsMarketingAgree = true;

            // 프로필 데이터 요청
            _self.getKakaoAccount(smsMarketingAgree);
          }
        },
        fail: (error) => {
          console.log(error);
        },
      });
    },
    getKakaoAccount(smsMarketingAgree) {
      window.Kakao.API.request({
        url: "/v2/user/me",
        success: (response) => {
          console.log("Kakao response", response);

          this.clearKakaoAccount();
          this.kakaoAccount = response.kakao_account;

          //0.아이디확인 -> 없으면:회원가입 || 있으면: -> 로그인
          this.kakaoAccount.endpoint = "kakaoCheckId";
          this.kakaoAccount.queryMethod = "POST";
          this.kakaoAccount.cell = this.$helper.makePhoneNumber(
            this.kakaoAccount.phone_number
          );
          this.kakaoAccount.smsMarketingAgree = smsMarketingAgree;
          this.saveDataPreLoginQuery(this.kakaoAccount).then((res) => {
            console.log("", res);

            // 회원가입 처리
            if (res.count === 0) {
              console.log("회원가입해야 함~~~");
              // this.getKakaoAgree();
              // return;
              this.setKakaoAccount(this.kakaoAccount);
              this.$emit("kakaoSignUp", this.kakaoAccount);
              return;
            }
            // 로그인 처리
            if (res.count > 0) {
              if (res.data.signupPath === "" || res.data.signupPath === null) {
                alert("일반회원으로 가입되어있습니다.");
                return;
              }
              this.loginId = res.data.loginId;
              this.password = "kakaoEmail_" + res.data.email;
              console.log("공통버튼 카카오로그인 성공");
              this.$emit("kakaoSignIn", this);
            }
          });
        },
        fail: (error) => {
          console.log(error);
        },
      });
    },
    kakaoLogout() {
      window.Kakao.Auth.logout((res) => {
        console.log(res);
      });
    },
    ...mapActions([
      "saveDataPreLoginQuery",
      "setKakaoAccount",
      "clearKakaoAccount",
    ]),
  },
};
</script>